<template>
    <div class="menu hidden-md-and-up">
    <v-menu
      bottom
      left
      min-width="250"
      :disabled="isSearchPage"
    >
      <v-btn
        slot="activator"
        icon
        :disabled="isSearchPage"
      >
        <v-icon>more_vert</v-icon>
      </v-btn>

      <v-list>

        <v-list-tile
          v-if="!isSearchPage"
          :disabled="!clientId && !parentId"
          @click="selectFiles">
          <v-list-tile-action>
            <v-icon
              color="primary"
              :disabled="!clientId && !parentId">
              cloud_upload</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Wyślij pliki</v-list-tile-title>
          </v-list-tile-content>
          <input ref="inputFile" type="file" @change="processFiles($event)" multiple
                 class="out-of-view"/>
        </v-list-tile>

        <v-list-tile
          v-if="!isSearchPage"
          :disabled="!clientId && !parentId"
          @click="showCreateFolderDialog()">
          <v-list-tile-action>
            <v-icon
              color="primary"
              :disabled="!clientId && !parentId">
              create_new_folder</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Utwórz folder</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-if="!isSearchPage"
          :disabled="selectedFiles.length <= 0"
          @click="showMoveDialog()"
        >
          <v-list-tile-action>
            <v-icon
              color="primary"
              :disabled="selectedFiles.length <= 0">
              folder_open</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Przenieś do...</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-if="!isSearchPage"
          :disabled="!dirsSelected"
          @click="showPermissionsDialog()"
        >
          <v-list-tile-action>
            <v-icon
              color="primary"
              :disabled="!dirsSelected">
              person_add</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Zarządzaj dostępem</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-if="!isSearchPage"
          :disabled="selectedFiles.length <= 0"
          @click="showDeleteDialog()"
        >
          <v-list-tile-action>
            <v-icon
              color="primary"
              :disabled="selectedFiles.length <= 0">
              delete</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Usuń</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'toolbar-menu',
  computed: {
    ...mapGetters('files', [
      'breadcrumbs',
      'selectedFiles',
    ]),
    ...mapGetters('user', [
      'details',
      'role',
    ]),
    isAdmin() {
      return this.role === 'admin' || this.role === 'super-admin';
    },
    clientId() {
      return this.$route.params.clientId;
    },
    parentId() {
      return this.$route.params.id;
    },
    searchKey() {
      const { query } = this.$route;
      if (query.search && query.search.trim()) {
        return `dla: ${query.search.trim()}`;
      }
      return false;
    },
    isSearchPage() {
      return this.$route.name === 'searchFiles';
    },
    noResults() {
      return this.filesList.length <= 0;
    },
    checkboxDisabled() {
      return this.$route.name === 'files' || this.noResults;
    },
    viewParams() {
      return {
        client_id: this.clientId,
        parent_item_id: this.parentId,
      };
    },
    dirsSelected() {
      return Boolean(this.selectedFiles.find(item => item.type === 1));
    },
    directoriesIds() {
      const ids = [];
      this.selectedFiles.forEach((file) => {
        if (file.type === 1) {
          ids.push(file.id);
        }
      });
      return ids;
    },
    itemsIds() {
      const ids = [];
      this.selectedFiles.forEach((file) => {
        ids.push(file.id);
      });
      return ids;
    },
  },
  methods: {
    ...mapActions('files', [
      'setDialogVisbility',
    ]),
    showDialog(dialogData) {
      const data = {
        ...dialogData,
        view: this.$route.name,
      };
      this.setDialogVisbility(data);
    },
    showCreateFolderDialog() {
      const dialogData = {
        type: 'createFolder',
        data: {
          client_id: this.clientId,
          parent_item_id: this.parentId,
        },
      };
      this.showDialog(dialogData);
    },
    showDeleteDialog() {
      const dialogData = {
        type: 'delete',
        items_id: this.itemsIds,
        viewParams: this.viewParams,
      };
      this.showDialog(dialogData);
    },
    showPermissionsDialog() {
      const hasFiles = this.selectedFiles.find(file => file.type === 2);
      const type = !hasFiles ? 'permissions' : 'permissions-alert';
      const dialogData = {
        type,
        data: {
          client_id: this.clientId,
          items_id: this.directoriesIds,
        },
        viewParams: this.viewParams,
      };
      this.showDialog(dialogData);
    },
    showMoveDialog() {
      const dialogData = {
        type: 'move',
        client_id: this.clientId,
        parent_item_id: this.parentId,
        viewParams: this.viewParams,
        items_id: this.itemsIds,
      };
      this.showDialog(dialogData);
    },
    selectFiles() {
      this.$refs.inputFile.click();
    },
    processFiles(event) {
      if (event.target.files.length > 0) {
        this.$eventBus.$emit('Files/FilesUpload/selectFiles', { files: event.target.files });
      }
    },
  },
};
</script>

<style scoped>
  .menu {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
    z-index: 100;
  }
</style>
